import React from "react";
import { RecoilRoot } from "recoil";
import { HelmetProvider } from "react-helmet-async";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/login/Login";
import Home from "./pages/home/Home";
import ZoomSettingsInitializer from "./components/ZoomSettingsInitializer";
import LoadingOverlay from "./components/common/LoadingOverlay";
import { useAuth } from "./hooks/useAuth";
import "./styles/variables.css";
import "./styles/global.css";
import "./App.css";

function AppContent() {
  const { loading } = useAuth();

  return (
    <>
      <ZoomSettingsInitializer />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
      <LoadingOverlay isVisible={loading} message="로그인 중..." />
    </>
  );
}

function App() {
  return (
    <RecoilRoot>
      <HelmetProvider>
        <AppContent />
      </HelmetProvider>
    </RecoilRoot>
  );
}

export default App;
